import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

export class ErrorMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
        }
    };
    formRef = React.createRef()

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let errorMessage = urlParams.get("errorMessage");
        this.setState({ errorMessage: errorMessage, isLoading: false, isReady: true });
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" /> 
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}